import { useInfiniteQuery } from "@tanstack/react-query";

import useSalesyApiClient from "@/hooks/useSalesyApiClient";

type Props = {
  id: string;
  query: string;
};

export const companyDetailPhonesQueryKey = (id: string, query: string) => ["company-detail-phones", id, query];

export const useCompanyDetailPhones = ({ id, query }: Props) => {
  const { apiClient } = useSalesyApiClient();

  return useInfiniteQuery({
    queryKey: companyDetailPhonesQueryKey(id, query || ""),
    queryFn: ({ pageParam = 0 }) =>
      apiClient.companyDetails.getPhones({
        id,
        itemsPerPage: 25,
        page: pageParam,
        query: query === "" ? undefined : query,
      }),
    staleTime: 1000 * 60 * 60,
    refetchOnWindowFocus: false,
    initialPageParam: 0,
    getNextPageParam: (lastPage) => {
      const { info } = lastPage || {};
      if (!info) return undefined;

      const itemsTotal = info?.items_total;
      if (!itemsTotal) return undefined;

      return info.page < Math.ceil(itemsTotal / info.items_per_page) - 1 ? info.page + 1 : undefined;
    },
  });
};
